import { ElementState, Preview } from "@creatomate/preview";
import { Subtitle, SubtitleSection } from "chq";
import createSubtitleElement from "./createSubtitleElement";
import hasBurnSubtitlesOn from "./hasBurnSubtitlesOn";
import addSpacesToText from "./addSpacesToText";

const loadSubtitle = async (
  onUpdateSubtitles: (newData: Record<string, any>) => void,
  subtitles: Subtitle[],
  subtitle: Subtitle,
  preview: Preview,
  elements: ElementState[],
  introTime: number,
  organization?: string,
  burnSubtitles?: boolean,
  element?: ElementState,
  language?: string
): Promise<string | undefined> => {
  let subtitleElement;
  const newTrack = (elements.reduce((max, el) => Math.max(max, el.track || 0), 0) || 0) + 1;

  const vttSections = subtitle.sections || [];
  const sectionsWithCreatomateId: SubtitleSection[] = [];
  const newElements = [];

  const { width, height } = preview.getSource();
  const videoIsLandscape = (width / height) > 1;
  const isOrientalFont = language?.includes("zh") || language === "jp" || language === "ja" || language === "ko";
  const landscapeInterval = isOrientalFont ? 28 : 50;
  const portraitInterval = isOrientalFont ? 15 : 28;
  const breakInterval = videoIsLandscape ? landscapeInterval : portraitInterval;

  for (let index = 0; index < vttSections.length; index += 1) {
    const section = vttSections[index];
    if (!section.hidden) {
      subtitleElement = createSubtitleElement(
        addSpacesToText(section.text, breakInterval),
        index,
        section.startTime + introTime,
        section.endTime + introTime,
        newTrack,
        organization,
        element,
        burnSubtitles !== undefined ? burnSubtitles : hasBurnSubtitlesOn(organization),
        language === "zh" ? subtitle.sourceLanguage : language
      );
      newElements.push(subtitleElement);
    }
    sectionsWithCreatomateId.push({
      ...section,
      originalStartTime: section.startTime + introTime,
      startTime: section.startTime + introTime,
      originalEndTime: section.endTime + introTime,
      endTime: section.endTime + introTime,
      creatomateId: subtitleElement?.id,
      track: newTrack
    });
  }

  // Update source to avoid undo/redo actions here
  const source = preview.getSource();
  await preview.setSource({
    ...source, elements: [...source.elements, ...newElements]
  }, false);

  onUpdateSubtitles({
    subtitles: subtitles.map(existingSubtitle => (
      existingSubtitle.id !== subtitle.id
        ? { ...existingSubtitle, active: false }
        : { ...subtitle, active: true, sections: sectionsWithCreatomateId }
    ))
  });

  return subtitleElement?.id;
};

export default loadSubtitle;
